<template>
  <div v-if="dataLoaded" class="card modal-overflow edit-job" style="box-shadow: none; margin-bottom:0px">
    <h6 style="color:red; padding:5px;">NOTE: This modal is not functional, and sounds like its probably unneccesary anyways</h6>
    <h5>Found {{ changesFound.length}} differences between the incoming Change PO and the previously accepted PO</h5>
    <el-table class="table-striped wrap-whole-words indexed-table-column-width"
              :data="changesFound"
              max-height="450">
      <el-table-column
                :width="this.constants.INDEX_COLUMN_WIDTHS.NARROW"
                align="center"
                label="#"
                type="index">
      </el-table-column>
      <el-table-column
                :min-width="100"
                align="center"
                label="Changed Field"
                prop="key">
                <template v-slot="props">
                  {{ props.row.key }}
                </template>
      </el-table-column>
      <el-table-column
                :min-width="100"
                align="center"
                label="Original Value"
                prop="original">
                <template v-slot="props">
                  {{ props.row.originalValue }}
                </template>
      </el-table-column>
      <el-table-column
                :min-width="100"
                align="center"
                label="Changed Value"
                prop="changed">
                <template v-slot="props">
                  {{ props.row.changedValue }}
                </template>
      </el-table-column>
      <el-table-column
                :min-width="150"
                align="center"
                label="New Value"
                prop="new">
                  <template v-slot="props">
                    <el-select class="select"
                                name="selectedChange"
                                size="large"
                                fit-input-width="true"
                                ref="changeSelect"
                                placeholder="Select Value"
                                v-model="selectedValues[props.row.key]"
                                @change="handleRequestedChangeMade($event, props.$index, props.row.key)">
                      <el-option class="select"
                        :value="props.row.originalValue"
                        :label="props.row.originalValue"
                        :key="props.row.key + props.row.originalValue">
                        {{ props.row.originalValue }}
                      </el-option>
                      <el-option class="select"
                        :value="props.row.changedValue"
                        :label="props.row.changedValue"
                        :key="props.row.key + props.row.changedValue">
                        {{ props.row.changedValue }}
                      </el-option>
                    </el-select>
                  </template>
      </el-table-column>
    </el-table>
    <div class=row>
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <button @click="handleAcceptAll" class="btn btn-md btn-fill btn-info pull-right">Accept All Incoming Changes</button>
      </div>
    </div>
  </div>
  <div v-else style="text-align: center;">
    <img src="static/img/loading.gif"/>
  </div>
</template>

<script>
import Constants from 'src/utilities/constants'
import Permissions from 'src/utilities/permissions'
import {notifyError, notifySuccess, utcToLocal,} from 'src/utilities/utils'
import AuditableEntity from 'src/components/UIComponents/AuditableEntity'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import ckEditorConfig from 'src/utilities/ckeditor'
import {OK} from 'http-status-codes'
import {sync} from 'vuex-pathify'

export default {
    props: ['jobId', 'purchaseOrder'],
    components: {
      AuditableEntity,
      ckeditor: CKEditor.component
    },
    computed: {
      ptracJob: sync('supplyPro/job/ptracJob'),
      changesFound: sync('supplyPro/purchaseOrder@changesFound'),
      canEdit() {
        if (this.$store.get('security/isInGroup', Constants.GROUPS.SUPER_USERS)) {
          return true
        }
        if (this.$store.get('supplyPro/job/ptracJob@actualCompletionDate')) {
          return false
        }
        return this.$can('edit', Permissions.JOBS)
      },
    },
    data() {
      return {
        editor: ClassicEditor,
        ckEditorConfig,
        changesSaved: true,
        constants: Constants,
        dataLoaded: false,
        selectedValues: {},
        modelValidations: {
          status: {
            required: true
          },
        },
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        return this.$validator.validateAll()
      },
      getLabel(obj) {
        if (obj != null && obj.hasOwnProperty('name')) {
          return obj.name
        }
        return obj
      },
      handleAcceptAll() {
        let index = 0
        for (const change of this.$store.get('supplyPro/purchaseOrder/changesFound')) {
          this.$set(this.selectedValues, change.key, change.changedValue)
          this.handleRequestedChangeMade(this.selectedValues, index, change.key)
          index++
        }
      },
      setChangesSaved(bool) {
        this.changesSaved = bool
      },
      async validateAndSubmit() {
        // Will have to implement logic here to take different actions depending on the field that changed.

        if (await this.$validator.validateAll()) {
          const savePayload = this.$store.get('supplyPro/job/savePayload')
          const response = await this.$store.dispatch('save', savePayload)

          if (response.result === Constants.RETURN_CODES.SUCCESS) {
            notifySuccess(this, 'Job saved successfully')
            this.setChangesSaved(true)
            this.$eventHub.$emit('jobSaved')
          } else {
            notifyError(this, 'Failed to Update Job', response.errors)
          }
        }
      },
      handleRequestedChangeMade(newValue, index) {
        this.$emit('requestedChangeMade', index, newValue)
      },
      initSelectedValues() {
        for (const change of this.$store.get('supplyPro/purchaseOrder/changesFound')) {
          this.$set(this.selectedValues, change.key, null)
        }
      }
    },
    async mounted() {
      let response = await this.$store.dispatch('fetchById', {endpoint: 'jobs', id: this.jobId})
      if (OK !== response.status) {
        notifyError(this, 'Failed to load Job by Id: ' + this.jobId)
        return
      }
      const job = response.data

      // dates coming from ptrac-api are a GMT date string
      job.dateReceived = utcToLocal(job.dateReceived)
      job.targetCompletionDate = utcToLocal(job.targetCompletionDate)

      this.$store.set('supplyPro/job/ptracJob', job)

      response = await this.$store.dispatch('supplyPro/purchaseOrder/findChanges')
      if (OK === response.status) {
        this.initSelectedValues()
        this.$emit('requestedChangesLoaded')
      } else {
        notifyError(this, response.data)
      }
      this.dataLoaded = true
    },
    beforeDestroy() {
      this.$store.commit('supplyPro/job/reset')
    }
  }
</script>

<style scoped>
  .edit-job >>> #autocomplete-client .v-autocomplete-list, #autocomplete-builder .v-autocomplete-list {
    min-width: 280px;
    margin-top: 12px;
  }
  .edit-job >>> .job-name-container {
    background-color: lightgrey;
    padding: 11px 0 4px 8px;
    border-radius: 5px;
  }
  .edit-job >>> .tiny-label-button {
    padding: 1px 5px;
    margin-top: -1px;
    float: right;
  }
</style>
